module.exports = __webpack_public_path__ + "static/img/twjd-sdo8.05b3120.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdo8.png
// module id = 865
// module chunks = 0